import React, { useEffect, useState } from 'react';
import axios from 'axios';

//styles
import styles from './NewUserModal.module.scss';

//functions
import { changeFaToEn } from '../functions/changeFaToEn';
import { notify } from '../functions/toasts';
import { responseHandler } from '../functions/responseHandler';

import { debounce, set } from 'lodash';
import CustomSelect from 'react-select';

const NewGroupModal = ({
  token,
  setAllGroups,
  setUpdateListGroups,
  UpdateListGroups,
}) => {
  const [users, setUsers] = useState([]);
  const [checkBtnCreate, setCheckBtnCreate] = useState(false);
  const [title, setTitle] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);

  const fetchUsers = async (name = '') => {
    try {
      const url = name
        ? `/user/list-for-select?last_name=${encodeURIComponent(name)}`
        : `/user/list-for-select`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        }));
        setUsers(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const debouncedFetchUsers = debounce((value) => {
    if (value.length >= 2) {
      fetchUsers(value);
    }
  }, 500);

  const handleInputChangeUser = (value) => {
    debouncedFetchUsers(value);
  };

  const handleChangeUser = (selectedOption) => {
    const users = selectedOption?.map((option) => option.value) || [];
    setSelectedUsers(users);
  };

  const inputHandler = (e) => {
    setTitle(e.target.value);
  };

  //for click on create newUser
  const createUserHandler = () => {
    setCheckBtnCreate(true);

    if (title === '' || selectedUsers.length === 0) {
      notify('برخی از موارد خواسته شده وارد نشده اند', 'error');
      setCheckBtnCreate(false);
      return;
    }

    const bodyNewGroup = {
      title: title,
      users: selectedUsers,
    };

    axios
      .post('/access-group/create', bodyNewGroup, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        responseHandler(res, 'succ');

        setAllGroups([]);
        setUpdateListGroups(!UpdateListGroups);

        setCheckBtnCreate(false);
        document.getElementById('closeNewUserModal').click();
      })
      .catch((error) => {
        responseHandler(error, 'error');
        setCheckBtnCreate(false);
      });
  };

  //for click on closeBtnModal and reset the inputs
  const closeBtnHandler = () => {
    setTitle('');
    setSelectedUsers([]);
  };

  return (
    <>
      <div
        className="modal fade"
        id="newGroupModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                ایجاد گروه جدید
              </h1>
            </div>
            <div className="modal-body">
              <div className={styles.divNewUser}>
                <div className={styles.Inputs}>
                  <label htmlFor="name">نام گروه:</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={title}
                    onChange={inputHandler}
                  />
                </div>

                {/* {users?.length > 0 && ( */}
                  <div>
                    <div
                      style={{
                        marginBottom: 200,
                      }}
                    >
                      <CustomSelect
                        isMulti
                        options={users}
                        placeholder="کاربر را انتخاب کنید"
                        onInputChange={handleInputChangeUser}
                        onChange={handleChangeUser}
                        isClearable
                        isSearchable
                        // value={userSelect}
                      />
                    </div>
                  </div>
                {/* )} */}
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ direction: 'ltr' }}
            >
              <button
                type="button"
                className="btn btn-secondary"
                id="closeNewUserModal"
                data-bs-dismiss="modal"
                onClick={closeBtnHandler}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={createUserHandler}
                disabled={checkBtnCreate}
              >
                ایجاد گروه
                {checkBtnCreate && (
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewGroupModal;
